(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/coupon/coupon-xperten.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/coupon/coupon-xperten.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.CouponXperten = Marionette.View.extend({
    regions: {
      reductions: '.region-reductions',
      xpertenResults: '.region-xperten-results'
    },

    className: 'view-coupon-xperten coupon coupon-xperten',

    template: function(data) {
      return svs.matchen.templates.coupon_xperten(data);
    },

    onRender: function() {
      this.showChildView(
        'reductions',
        new svs.matchen.views.Reductions({
          collection: this.model.getReductions(),
          xperten: true
        })
      );

      this.showChildView(
        'xpertenResults',
        new svs.matchen.views.Results({
          collection: this.options.results
        })
      );

      this.trigger('resize:tab:view');
    }
  });
})(Backbone, _, svs);


 })(window);